import { render, staticRenderFns } from "./TransferTab2.vue?vue&type=template&id=daae025a"
import script from "./TransferTab2.vue?vue&type=script&lang=js"
export * from "./TransferTab2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports